const CLIENT_KEY = "ideaforge_client_id";
const PRO_KEY = "ideaforge_pro_email";

export const getClientId = () => {
  let id = localStorage.getItem(CLIENT_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(CLIENT_KEY, id);
  }
  return id;
};

export const getProEmail = () => localStorage.getItem(PRO_KEY);
export const setProEmail = (email) => localStorage.setItem(PRO_KEY, email.toLowerCase());

export const accountHeaders = () => {
  const h = { "X-Client-Id": getClientId() };
  const pro = getProEmail();
  if (pro) h["X-Pro-Email"] = pro;
  return h;
};
